import styled from '@emotion/styled';

export const MapContainer = styled.div`
  position: relative;
  height: 100%;
  background: #f2efe9; // default google map background

  .poi-info-window a:link {
    display: none;
  }
`;
